import { portalConfig } from './portal-config.js';

export async function apiFetch(path: string, idToken: string, init: RequestInit = {}): Promise<Response> {
  const res = await fetch(`${portalConfig.apiBase}${path}`, {
    ...init,
    headers: { ...(init.headers ?? {}), Authorization: `Bearer ${idToken}` }
  });
  if (res.status === 401) {
    throw new Error('unauthorized');
  }
  return res;
}

export async function apiJson<T>(path: string, idToken: string): Promise<T> {
  const res = await apiFetch(path, idToken);
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json() as Promise<T>;
}
